import { render, staticRenderFns } from "./SkeletonLoaderWrapper.vue?vue&type=template&id=3f61f3ae"
import script from "./SkeletonLoaderWrapper.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoaderWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports